﻿/**
 * <image-loader> — 子图片加载完成后给组件加上 loaded 属性。
 * 通过 snippets/header-script.liquid 全站加载一次。
 *
 * @example
 * {% render 'image-loader', image: section.settings.pc_img, class: 'pc-show' %}
 */
(function () {
  "use strict";

  if (customElements.get("image-loader")) return;

class ImageLoader extends HTMLElement {
  connectedCallback() {
    this.clearLoadListener();
    const img = this.querySelector("img");

    if (!img) return;

    const handleLoad = () => {
      if (!this.isConnected || this.querySelector("img") !== img) return;
      this.setAttribute("loaded", "");
      this.clearLoadListener();
    };

    if (img.complete && img.naturalWidth > 0) {
      this.setAttribute("loaded", "");
      return;
    }

    this._loadCleanup = () => img.removeEventListener("load", handleLoad);
    img.addEventListener("load", handleLoad);
  }

  disconnectedCallback() {
    this.clearLoadListener();
  }

  clearLoadListener() {
    this._loadCleanup?.();
    this._loadCleanup = null;
  }
}

  customElements.define("image-loader", ImageLoader);
})();
